import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FilterMappingService } from 'src/app/services/results/filter-mapping.service';
import { constants } from 'src/environments/constants';
@Component({
  selector: 'app-availability-filters',
  templateUrl: './availability-filters.component.html',
  styleUrls: ['./availability-filters.component.scss']
})
export class AvailabilityFiltersComponent implements OnInit {
  @Output() availabilityToFilterBy: EventEmitter<string[]> = new EventEmitter();
  selectedAvailability: string[] = [];
  title: string = "";
  instockKeyword: string = "";
  touchscreenLabel: string = "";
  showInStockInfo: boolean = false;

  constructor(private analytics: AnalyticsService, private confSvc: ConfigService, private filterMapper: FilterMappingService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("availabilityFilterTitle");
    this.instockKeyword = constants.INSTOCK;
    this.touchscreenLabel = this.filterMapper.getFeatureFilterLabel(this.instockKeyword);
    this.showInStockInfo = this.confSvc.getBool("showInStockInfo");
  }

  availabilityIsSelected(availability: string): boolean {
    return this.selectedAvailability.some(f => f === availability);
  }

  onAvailabilityChange(availability: string): void {
    const indexOfAvailability = this.selectedAvailability.indexOf(availability);
    indexOfAvailability < 0 ? this.selectedAvailability.push(availability) : this.selectedAvailability.splice(indexOfAvailability, 1);
    this.availabilityToFilterBy.emit(this.selectedAvailability);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.feature, availability, indexOfAvailability < 0);
  }

}
